module.exports = __webpack_public_path__ + "assets/img/bb16cbfa1585689355b75acd4f0fbbc2.png";